export default __webpack_public_path__ + "static/media/logo-tasc.93df7548.png";